import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette }) => ({
  container: {
    marginBottom: 24,
  },
  name: {
    fontSize: 34,
  },
  arrow: {
    borderRight: `2px solid ${palette.grey[200]}`,
    paddingRight: 24,
    marginRight: 12,
    display: "flex",
    alignItems: "center",
  },
  settingsText: {
    fontWeight: 600,
  },
}));

export default useStyles;
